module.exports = __webpack_public_path__ + "brandon_light-webfont.7f6e797be8a9792f59f3.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_light-webfont.woff2
// module id = 940
// module chunks = 7